import {
  Injectable,
  ComponentFactoryResolver,
  ViewContainerRef,
  Inject,
  ApplicationRef,
  Injector,
  EmbeddedViewRef
} from '@angular/core';
import { OffCanvasComponent } from './off-canvas/off-canvas.component';
import SidePanel from './side-panel';
import { SidePanelWrapperComponent } from './side-panel-wrapper/side-panel-wrapper.component';
import { ActiveSidePanelService } from './active-side-panel.service';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SidePanelService {
  private panel: ViewContainerRef;
  private openPanels: SidePanel<any>[] = [];

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    @Inject(DOCUMENT) private document: Document,
    private applicationRef: ApplicationRef,
    private injector: Injector,
    private activeSidePanel: ActiveSidePanelService
  ) {
    const wrapperComponentRef = this.componentFactoryResolver
      .resolveComponentFactory(SidePanelWrapperComponent)
      .create(this.injector);
    this.applicationRef.attachView(wrapperComponentRef.hostView);
    const domElement = (wrapperComponentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;
    this.document.body.appendChild(domElement);
    this.panel = wrapperComponentRef.instance.sidePanelTarget;
  }

  open<T>(
    component: any,
    big = false,
    componentFactoryResolver: ComponentFactoryResolver = null
  ): SidePanel<T> {
    const cfr = componentFactoryResolver
      ? componentFactoryResolver
      : this.componentFactoryResolver;

    // create off canvas
    const offCanvasComponentFactory = cfr.resolveComponentFactory(
      OffCanvasComponent
    );
    const offCanvasComponentRef = this.panel.createComponent(
      offCanvasComponentFactory
    );
    offCanvasComponentRef.instance.bigCanvas = big;
    offCanvasComponentRef.instance.sidePanelService = this;

    // insert component instance into off canvas
    const componentFactory = cfr.resolveComponentFactory(component);
    const viewContainerRef = offCanvasComponentRef.instance.canvasContent;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(componentFactory);

    // open panel
    setTimeout(() => {
      offCanvasComponentRef.instance.open();
    });

    const sidePanel = {
      panel: offCanvasComponentRef.instance,
      component: componentRef.instance as T
    };
    sidePanel.panel.closed$.subscribe(() => {
      offCanvasComponentRef.destroy();
      this.openPanels.splice(this.openPanels.findIndex(sp => sp === sidePanel));
      this.activeSidePanel.set(this.openPanels[this.openPanels.length - 1]);
    });
    this.openPanels.push(sidePanel);

    this.activeSidePanel.set(sidePanel);

    // return off canvas component instance
    return sidePanel;
  }

  replace(replacePanel: SidePanel<any>, component: any, big = false) {
    replacePanel.panel.bigCanvas = big;

    // insert component instance into off canvas
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      component
    );
    const viewContainerRef = replacePanel.panel.canvasContent;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(componentFactory);

    // destroy old component
    // replacePanel.component.destroy();

    // replace component instance
    replacePanel.component = componentRef.instance;

    // return off canvas component instance
    return replacePanel;
  }

  openPanelsCount(): number {
    return this.openPanels.length;
  }

  panelIndex(panel: OffCanvasComponent): number {
    return this.openPanels.findIndex(sp => sp.panel === panel);
  }
}
